<template>
  <cus-order-dialog>
    <template v-slot:title>
      <div v-if="!is_detail" class="search-button d-flex">
        <cus-button
          text="條件搜尋"
          color="blue"
          :width="50"
          style="min-height: 45px"
          @click="openInnerDialog('advancedSearch')"
        ></cus-button>
      </div>
      <p v-if="is_detail" class="dialog-title">訂單管理：查看訂單</p>
      <p v-else-if="getSearchingStatus" class="dialog-title">訂單管理：搜尋結果</p>
      <p v-else class="dialog-title">訂單管理</p>
    </template>
    <template v-slot:body>
      <div class="body-wrap">
        <!--  訂單列表 -->
        <div v-if="!is_detail" class="order-list">
          <div class="bar">
            <!-- 當日當班 -->
            <div v-if="!getSearchingStatus" class="time-range bar-btn">
              <p :class="listRange === 'section' ? 'select' : ''" @click="listRange = 'section'">當班</p>
              <p :class="listRange === 'day' ? 'select' : ''" @click="listRange = 'day'">當日</p>
            </div>
            <!-- 搜尋條件 -->
            <div v-else class="search-condition" :class="listRange === 'search' ? 'search-condition-select' : ''">
              <div class="text" @click="listRange = 'search'">篩選條件：{{ search_text }}</div>
              <cus-button
                text="清除"
                color="red"
                fontSize="small"
                buttonClass="clear"
                @click="handleClearSearch"
              ></cus-button>
            </div>
            <div class="un-writeoff bar-btn">
              <p :class="listRange === 'un_writeoff' ? 'select' : ''" @click="listRange = 'un_writeoff'">未沖銷</p>
            </div>
          </div>
          <order-list
            type="manage"
            :orderList="orderList"
            v-model:selectOrder="selectOrder"
            v-model:listPage="listPage"
          ></order-list>
        </div>
        <!--  查看訂單 -->
        <div v-else class="order-detail">
          <all-detail-info :orderData="orderData"></all-detail-info>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button v-if="!is_detail" text="關閉" color="white" :width="25" @click="close"></cus-button>
        <cus-button v-else text="返回" color="white" :width="!is_detail ? 50 : 25" @click="backToList"></cus-button>
        <cus-button v-if="is_detail" text="補印發票" color="white" :width="25" @click="handleReprint"></cus-button>
        <cus-button
          v-if="listRange === 'un_writeoff'"
          text="沖銷"
          :color="is_detail ? 'blue' : 'white'"
          :width="is_detail ? 50 : 25"
          :disabled="!selectOrder"
          @click="handleWriteoffOrder"
        ></cus-button>
        <cus-button
          v-else-if="selectOrder?.status === 18"
          text="複製"
          :color="is_detail ? 'blue' : 'white'"
          :width="is_detail ? 50 : 25"
          :disabled="!selectOrder"
          @click="handleDuplicateOrder"
        ></cus-button>
        <cus-button
          v-else
          text="作廢"
          :color="is_detail ? 'blue' : 'white'"
          :width="is_detail ? 50 : 25"
          :disabled="!selectOrder"
          @click="handleVoidOrder"
        ></cus-button>
        <cus-button
          v-if="!is_detail"
          text="查看訂單"
          color="blue"
          :width="50"
          :disabled="!selectOrder"
          @click="handleClickDetail"
        ></cus-button>
      </div>
    </template>
  </cus-order-dialog>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
  <component :is="inner_dialogTemplate"></component>
</template>
<script>
import { ref, inject, defineAsyncComponent, watch, getCurrentInstance } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { useDialog, useDialogInDialog } from '@/utils/dialog';
import { mapValue, getPaymentType } from '@/utils/define';
export default {
  name: 'manage-order',
  components: {
    OrderList: defineAsyncComponent(() => import('@/components/orderDialog/OrderList.vue')),
    AllDetailInfo: defineAsyncComponent(() => import('@/components/orderDialog/AllDetailInfo.vue')),
    AdvancedSearch: defineAsyncComponent(() => import('@/components/orderDialog/AdvancedSearch.vue')),
    ReprintInvoice: defineAsyncComponent(() => import('@/components/orderDialog/ReprintInvoice.vue')),
    Alert: defineAsyncComponent(() => import('@/components/dialog/Alert.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    //接受provide參數
    const dialogVisible = inject('order_dialogVisible');
    const close = inject('order_close');
    const controlCloseButton = inject('order_controlCloseButton');
    //設定參數
    const listRange = ref('section'); // section-當班,day-當日,un_writeoff-未沖銷,search-搜尋
    const selectOrder = ref(null);
    const listPage = ref(1);
    const getPageItem = useGetters('handleOrder', ['getPageItem']);
    //取得訂單列表
    const doGetManageOrderList = useActions('manageOrder', ['doGetManageOrderList']);
    const { getAllManageOrderList, getSearchList } = useGetters('manageOrder', [
      'getAllManageOrderList',
      'getSearchList',
    ]);
    const orderList = ref([]);
    const getOrderList = (range) => {
      switch (range) {
        case 'section':
          orderList.value = getAllManageOrderList.value.section;
          break;
        case 'day':
          orderList.value = getAllManageOrderList.value.day;
          break;
        case 'un_writeoff':
          orderList.value = [];
          getAllManageOrderList.value.day.forEach((e) => {
            if (e.status === 16) orderList.value.push(e);
          });
          break;
        case 'search':
          orderList.value = getSearchList.value;
          break;
      }
    };
    //監聽清單
    watch([getAllManageOrderList, getSearchList], () => {
      getOrderList(listRange.value);
    });
    //bar切換
    watch(
      listRange,
      async () => {
        if (listRange.value === 'section') await doGetManageOrderList();
        getOrderList(listRange.value);
        listPage.value = 1;
        selectOrder.value = null;
      },
      { immediate: true }
    );
    //查看訂單
    const orderData = ref();
    const is_detail = ref(false);
    watch(is_detail, () => {
      controlCloseButton(is_detail.value);
    });
    const doGetOrderInfo = useActions('manageOrder', ['doGetOrderInfo']);
    const handleClickDetail = async () => {
      const res = await doGetOrderInfo(selectOrder.value.order_id);
      orderData.value = res;
      is_detail.value = true;
    };
    //返回列表
    const backToList = () => {
      is_detail.value = false;
      orderData.value = null;
    };

    //條件搜尋
    const search_text = ref('');
    const { inner_dialogTemplate, openInnerDialog, closeInnerDialog } = useDialogInDialog();
    const { getSearchingStatus, getSearchCondition } = useGetters('manageOrder', [
      'getSearchingStatus',
      'getSearchCondition',
    ]);
    const doSearchOrder = useActions('manageOrder', ['doSearchOrder']);
    const handleSearchOrder = async (val) => {
      await doSearchOrder(val);
      closeInnerDialog();
      listPage.value = 1;
      selectOrder.value = null;
      listRange.value = 'search';
    };
    //搜尋條件文字
    watch(getSearchCondition, () => {
      let list = [];
      Object.keys(getSearchCondition.value).forEach((e) => {
        if (e === 'date_range') return;
        else if (e === 'date_type') {
          list.push(mapValue.date_type[getSearchCondition.value[e] - 1]);
        } else if (e === 'source' || e === 'take_away_method') {
          list.push(mapValue[getSearchCondition.value[e]]?.label || '');
        } else {
          list.push(getSearchCondition.value[e]);
        }
      });
      const text_1 = list
        .slice(0, 5)
        .filter((e) => e)
        .join('，');
      const text_2 =
        list.slice(-4).filter((e) => e).length > 0
          ? '，' +
            list
              .slice(-4)
              .filter((e) => e)
              .join('/')
          : '';
      search_text.value = text_1 + text_2;
    });
    //清除搜尋
    const CLEAR_SEARCH = useMutations('manageOrder', ['CLEAR_SEARCH']);
    const handleClearSearch = () => {
      CLEAR_SEARCH();
      if (listRange.value === 'search') listRange.value = 'section';
    };
    watch(dialogVisible, () => {
      CLEAR_SEARCH();
    });

    //開啟彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();

    //執行作廢
    const doInvalidOrder = useActions('manageOrder', ['doInvalidOrder']);
    const invalidOrder = async (data) => {
      try {
        //特定支付方式需要開啟掃描(同時須改api的timeout以及loading動畫)
        if (
          selectOrder.value.payment_method === 'credit_card' ||
          selectOrder.value.payment_method === 'easy_card' ||
          selectOrder.value.payment_method === 'i_pass'
        ) {
          openDialog(
            'checkoutScan',
            { order_id: selectOrder.value.order_id },
            { dialogContent: `請感應/掃描<br/>${getPaymentType(selectOrder.value.payment_method).label}` }
          );
          data.timeout = 120000;
          data.loading = false;
        }
        await doInvalidOrder(data);
        closeDialog();
        if (!data.with_duplicate) {
          //直接作廢
          //更新selectOrder
          selectOrder.value = orderList.value.find((e) => e.order_id === selectOrder.value.order_id);
          listPage.value =
            Math.ceil(
              (orderList.value.findIndex((e) => e.order_id === selectOrder.value.order_id) + 1) / getPageItem.value
            ) || 1;
          //更新OrderData
          if (is_detail.value) {
            const res = await doGetOrderInfo(selectOrder.value.order_id);
            orderData.value = res;
          }
        } else {
          //作廢並複製
          close();
        }
      } catch (error) {
        closeDialog();
      }
    };
    const handleVoidOrder = async () => {
      console.log("order", selectOrder.value);
      let foo = {
      };

      if ( selectOrder.value.source === 'APP訂單') {
        foo = {
          content: `是否確定要作廢此訂單？<${selectOrder.value.serial_code}>`,
          confirmText: '直接作廢',
          moreConfirm: true,
          hideCancelButton : true,
        };
      }
      else {
        foo = {
          content: `是否確定要作廢此訂單？<${selectOrder.value.serial_code}><br/>若需要以相同品項建立新訂單，請點選「作廢並複製」`,
              confirmText: '直接作廢',
            confirm2Text: '作廢並複製',
            moreConfirm: true,
        }
      }



      proxy
          .$confirm(foo)
          .then((val) => {
            if (val === '直接作廢')
              invalidOrder({
                order_id: selectOrder.value.order_id,
                with_duplicate: false,
              });
            else if (val === '作廢並複製')
              invalidOrder({
                order_id: selectOrder.value.order_id,
                with_duplicate: true,
              });
          })
          .catch((e) => e);
    };

    //複製訂單
    const doDuplicateOrder = useActions('manageOrder', ['doDuplicateOrder']);
    const handleDuplicateOrder = async () => {
      await doDuplicateOrder(selectOrder.value.order_id);
      close();
    };

    //沖銷訂單
    const doWriteOffOrder = useActions('manageOrder', ['doWriteOffOrder']);
    const handleWriteoffOrder = () => {
      proxy
        .$confirm({
          content: `是否確定要沖銷此訂單？<${selectOrder.value.serial_code}>`,
        })
        .then(async () => {
          await doWriteOffOrder(selectOrder.value.order_id);
          //更新selectOrder
          selectOrder.value = orderList.value.find((e) => e.order_id === selectOrder.value.order_id);
          if (listPage.value > (Math.ceil(orderList.value.length / getPageItem.value) || 1)) {
            listPage.value = Math.ceil(orderList.value.length / getPageItem.value) || 1;
          }
          //更新OrderData
          if (is_detail.value) {
            const res = await doGetOrderInfo(selectOrder.value.order_id);
            orderData.value = res;
          }
        })
        .catch((e) => e);
    };

    //補印發票
    const handleReprint = () => {
      openInnerDialog('reprintInvoice', { order_id: selectOrder.value.order_id });
    };

    return {
      close,
      listRange,
      selectOrder,
      listPage,
      orderList,
      orderData,
      is_detail,
      handleClickDetail,
      backToList,
      inner_dialogTemplate,
      openInnerDialog,
      getSearchingStatus,
      search_text,
      handleSearchOrder,
      handleClearSearch,
      dialogTemplate,
      handleVoidOrder,
      handleDuplicateOrder,
      handleWriteoffOrder,
      handleReprint,
    };
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 2.4rem;
  line-height: 60px;
  color: $color-blue;
}
.search-button {
  width: 280px;
  position: absolute;
  top: 16px;
  left: 16px;
}
$bar-height: 6vh;
.body-wrap {
  position: relative;
  padding: 0 4px;
}
.order-list {
  height: 100%;
  padding: 20px 0 0;
  display: grid;
  grid-template-rows: $bar-height auto;
  grid-gap: 8px;

  .bar {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-column-gap: 8px;
    .bar-btn {
      background-color: $color-gray-6;
      border-radius: 27px;
      text-align: center;
      font-size: 2.2rem;
      color: $color-blue;
    }
    .time-range {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
    p {
      line-height: $bar-height;
      transition: 0.2s;
      border-radius: 27px;
      cursor: pointer;
    }
    p.select {
      background-color: $color-blue;
      color: #fff;
    }
    .search-condition {
      background-color: $color-gray-6;
      color: $color-blue;
      border-radius: 27px;
      font-size: 2.2rem;
      padding: 3px 16px;
      overflow: hidden;
      display: grid;
      grid-template-columns: minmax(0, auto) 120px;
      align-items: center;
      transition: 0.2s;
      cursor: pointer;
      .text {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 2rem;
        line-height: calc($bar-height - 6px);
      }
      &-select {
        background-color: $color-blue;
        color: #fff;
      }
      :deep(.clear) {
        .button {
          border-radius: 27px;
          font-size: 1.8rem !important;
        }
        min-height: 75%;
        max-height: 40px;
      }
    }
  }
}
.order-detail {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
